import React , {useState} from "react";
import { Redirect, withRouter } from "react-router-dom";
import firebase from "./Config";
import swal from 'sweetalert';

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [routeRedirect, setRedirect] = useState(false);
    
    const login = async(e) => {
        e.preventDefault();
        let response = await firebase.login(email, password);
        swal("Login Success!", "Credentials Verified!", "success");
        setRedirect(true);
        if(response.hasOwnProperty("message")){
           // console.log("user");
        }
        if(response.hasOwnProperty("user")){
            //console.log(response.user);
            setRedirect(true);
        }

    }
    

    const redirect = routeRedirect;
    if(redirect){
        return <Redirect to="/" />  
    }


    return(
     <>
    <div class="container py-4 py-lg-5 my-4">
      <div class="row">
          <div className="col-md-3"></div>
        <div class="col-md-6 ">
          <div class="card border-0 box-shadow">
            <div class="card-body">
              <h2 class="h4 mb-1">Sign In</h2>
              <div class="py-3">
                <h3 class="d-inline-block align-middle font-size-base font-weight-semibold mb-2 mr-2">Verify Credentials:</h3>
                <div class="d-inline-block align-middle"><a class="social-btn sb-google mr-2 mb-2" href="/password" data-toggle="tooltip" title="Reset Your Password">
                <i class="fas fa-lock"></i></a>
                <a class="social-btn sb-facebook mr-2 mb-2" href="/password" data-toggle="tooltip" title="Verify Email">
                    <i class="far fa-envelope sequare"></i></a>
                   </div>
              </div>
              
              <h3 class="font-size-base pt-4 pb-2">Or Provide Your Credentials</h3>
              <form class="needs-validation" novalidate onSubmit={login}>
                <div class=" form-group">
               
                  <input class="form-control prepended-form-control" type="email"  name="email" onChange={(e) => setEmail(e.target.value) } placeholder="Email" required />
                </div>
                <div class="input-group-overlay form-group">
                 
                    <input class="form-control prepended-form-control"  name="password"  placeholder="Password" type="password" onChange={(e) => setPassword(e.target.value)} required />
                   
                  
                </div>
                <div class="d-flex flex-wrap justify-content-between">
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox"  checked id="remember_me" />
                    <label class="custom-control-label" for="remember_me">Remember me</label>
                  </div><a class="nav-link-inline font-size-sm" href="/password">Forgot password?</a>
                </div>
                <hr class="mt-4"></hr>
                <div class="text-right pt-4">
                  <button class="btn btn-primary" type="submit" ><i class="czi-sign-in mr-2 ml-n21"></i>Sign In</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-3"></div>
        </div>
        </div>
       
      
        
           
        </>
    )

}

export default withRouter(Login);